import { isPositionVisible } from "../services/timeline";

import { getAutoScroll, setAutoScroll } from "../state/autoScroll";

export default function enableAutoScroll(onlyIfVisible) {
	if (!getAutoScroll() && (!onlyIfVisible || isPositionVisible())) {
		setAutoScroll(true);
	}
}
